var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2169 11.912L21.0036 1.00167C19.2622 -0.333889 16.7359 -0.333889 14.9945 1.00167L0.783141 11.9102C0.284265 12.2925 0 12.8581 0 13.4627V33.9904C0 35.093 0.950688 36 2.11787 36H11.6473C12.8145 36 13.7652 35.093 13.7652 33.9904V20.9977H22.2348V33.9904C22.2348 35.093 23.1855 36 24.3527 36H33.8821C35.0493 36 36 35.093 36 33.9904V13.4627C35.9981 12.8581 35.7138 12.2925 35.2169 11.912Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.5f9537e0247213053f4854ddc2c87ba9.svg";
export { ForwardRef as ReactComponent };